import Vue from 'vue';
import VueI18n from 'vue-i18n'
import elementuiEn from "element-ui/lib/locale/lang/en";
import elementuiZh from "element-ui/lib/locale/lang/zh-CN";
import en from './local_en.js';//英语
import zh from './local_zn.js';//中文
import ja from './local_ja.js';//日语
import ko from './local_ko.js';//韩语
import nl from './local_nl.js';//荷兰语
import vi from './local_vi.js';//越南语
import ru from './local_ru.js';//俄语
import pt from './local_pt.js';//葡萄语
import it from './local_it.js';//意大利语
import id from './local_id.js';//印度尼西亚语
import fr from './local_fr.js';//法语
import es from './local_es.js';//西班牙语
import de from './local_de.js';//德语
import th from './local_th.js';//泰语
import ar from './local_ar.js';//阿拉伯语





Vue.use(VueI18n);

const messages = {
    en: Object.assign(en, elementuiEn),
    zh: { ...zh, ...elementuiZh },
    ja: ja,
    ko: ko,
    nl: nl,
    vi: vi,
    ru: ru,
    pt: pt,
    it: it,
    id: id,
    fr: fr,
    es: es,
    de: de,
    th: th,
    ar: ar,


}

// localStorage.setItem('locale', 'zh')
const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || "zh",
    messages
})


export default i18n;



// WEBPACK FOOTER //
// ./src/assets/language/index.js